export class Currency {
  private constructor(
    public readonly alphabeticalCode: string,
    public readonly minorUnit: number,
  ) {
    if (this.minorUnit < 0) {
      throw new Error("Minor unit must be greater than 0");
    }
    if (this.alphabeticalCode.length !== 3) {
      throw new Error("Alphabetical code must be 3 characters long");
    }
  }

  static EUR = new Currency("EUR", 2);
  static USD = new Currency("USD", 2);

  static create(data: {
    alphabeticalCode: string;
    minorUnit: number;
  }): Currency {
    return new Currency(data.alphabeticalCode, data.minorUnit);
  }

  round(amount: number): number {
    const factor = 10 ** this.minorUnit;
    return Math.round(amount * factor) / factor;
  }

  toMinorUnit(amount: number): number {
    return Math.round(amount * 10 ** this.minorUnit);
  }
}
